<script setup lang="ts">
import { ref } from 'vue';

/**
 * Paired with `UiField`, which owns the label, the hint and the id.
 */
withDefaults(
	defineProps<{
		type?: 'text' | 'email' | 'month';
		invalid?: boolean | undefined;
		disabled?: boolean | undefined;
		placeholder?: string | undefined;
	}>(),
	{ type: 'text', invalid: false, disabled: false },
);

const model = defineModel<string>({ required: true });

/**
 * So a dialog can put the cursor where the user is about to type.
 *
 * `<script setup>` exposes nothing by default, so a `ref` on this component
 * would otherwise hand back an instance with no input on it.
 */
const element = ref<HTMLInputElement>();
defineExpose({
	focus: () => {
		element.value?.focus();
	},
});
</script>

<template>
	<input
		ref="element"
		v-model="model"
		:type="type"
		:disabled="disabled"
		:placeholder="placeholder"
		:aria-invalid="invalid || undefined"
		class="border-border bg-surface text-fg placeholder:text-muted/70 focus:border-accent w-full rounded-lg border px-3 py-2 text-sm shadow-xs transition-colors disabled:pointer-events-none disabled:opacity-50"
	/>
</template>
